import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Clients() {

        const [agent, setAgent] = useState('')
        const [agentCode, setAgentcode] = useState('')
        const [extensions, setExtensions] = useState([])
        const [currentPage, setCurrentPage] = useState(1);
        const rowsPerPage = 20;
        const totalPages = Math.ceil(extensions.length / rowsPerPage);
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
        const [modal, setModal] = useState(false)
        const [mobile, setMobile] = useState('')
        const [amount, setAmount] = useState(0)
        const [topupText, setTopuptext] = useState('TOP UP NOW')

        const [firstName, setFirstname] = useState("")
        const [lastName, setLastname] = useState("");
        const [otherNames, setOthernames] = useState("");
        const [phone, setPhone] = useState("");
        const [email, setEmail] = useState("");
        const [idNumber, setIDNumber] = useState("");
        const [pin, setPin] = useState("");
        const [submitText, setSubmittext] = useState('SUBMIT')

        const toggle=()=>{
            setModal(!modal)
        }

        useEffect(() => {
    
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
        
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`);
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }
            if(agent){
                getAgentcode()
            }
        },[agent])

        const getClients =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients2?agent=${agentCode}`)
            const data = await res.json();
            setExtensions(data)

        }
    
        useEffect(()=>{
           
    
        const getClients =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients2?agent=${agentCode}`)
            const data = await res.json();
            setExtensions(data)

        }

        if(agentCode){
            
            getClients()
        }
    
        },[agentCode])
    

  const createClient =async()=>{
    if(firstName && lastName && phone && email && idNumber && pin){
        setSubmittext('PLEASE WAIT...');
        const res = await fetch('https://digitalapi.definiteassurance.com/api/createClient',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({firstName,lastName,otherNames,phone,email,idNumber,pin, agent:agentCode}),
            credentials:"include"
        })

        const data = await res.json();
        const {success,exists} = data;
        if(success && !exists){
            setFirstname('')
            setLastname('')
            setOthernames('')
            setPhone('')
            setEmail('')
            setIDNumber('')
            setPin('')
            setSubmittext('SUBMIT');
            getClients()
            toast.success('Client added successfully')
            setModal(false)

        }
        else if(!success && exists){
            setSubmittext('SUBMIT');
            toast.error('Submitted details already exists!')
        }
        else{
            setSubmittext('SUBMIT');
            toast.error('Something went wrong!')
        }
    }
    else{
        toast.error('All fields marked * are required')
    }
  }
      
  return (
    <div>
        <div className="page-content">
            <ToastContainer />
        <Breadcrumbs title="Definite Assurance" breadcrumbItem={`CLIENTS`} />
        <Card className="mini-stats-wid">
            <CardBody>
              
                
                <hr />
                
                <Button color="info" onClick={toggle}>+NEW CLIENT</Button>
                       
                
                
                <div className="table-responsive" style={{padding:'10px'}}>


                <Table striped bordered hover id="policy-table">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">NAME</th>
                    <th scope="col">PHONE</th>     
                    <th scope="col">EMAIL</th>
                    <th scope="col">KRA PIN</th>
                    


                    </tr>
                </thead>
                <tbody>
                    {currentPolicies.map((val, index) => {
                    // Calculate the correct index based on current page
                    const globalIndex = indexOfFirstRow + index;
                    const transactionDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.DateDone)
                            return (
                                <tr key={val.OID}>
                                <td>{index + 1}</td>
                                <td>{val.Dealer_name}</td>
                               
                                <td>{val.Mobile}</td>
                                <td>{val.Email}</td>
                                <td>{val.Pin}</td>
                                </tr>
                            );

                    })}
                </tbody>
                </Table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center">
                <div>
                    Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                </div>
                <div>
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    >
                    Previous
                    </button>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </button>
                    ))}
                    
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    >
                    Next
                    </button>
                </div>
                </div>
                </div>
                
            </CardBody>
        </Card>
        </div>


    <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader>NEW CLIENT</ModalHeader>
        <div className="modalContainer">
            <div className="entryRow2">
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="FIRST NAME*" onChange={(e)=>{setFirstname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={firstName}  type="text" placeholder="FIRST NAME" />
            </FloatingLabel>

            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="LAST NAME*" onChange={(e)=>{setLastname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={lastName}  type="text" placeholder="LAST NAME" />
            </FloatingLabel>

            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="OTHER NAMES" onChange={(e)=>{setOthernames(e.target.value)}}>
                <Form.Control  className='inputSearch' value={otherNames}  type="text" placeholder="OTHER NAMES" />
            </FloatingLabel>

            </div>

            <div className="entryRow2">
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="PHONE NUMBER*" onChange={(e)=>{setPhone(e.target.value)}}>
                <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="PHONE NUMBER" />
            </FloatingLabel>

            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="EMAIL ADDRESS*" onChange={(e)=>{setEmail(e.target.value)}}>
                <Form.Control  className='inputSearch' value={email}  type="text" placeholder="EMAIL ADDRESS" />
            </FloatingLabel>

            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="IDENTIFICATION NUMBER*" onChange={(e)=>{setIDNumber(e.target.value)}}>
                <Form.Control  className='inputSearch' value={idNumber}  type="text" placeholder="IDENTIFICATION NUMBER" />
            </FloatingLabel>

            </div>
            <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="KRA PIN*" onChange={(e)=>{setPin(e.target.value)}}>
                <Form.Control  className='inputSearch' value={pin}  type="text" placeholder="KRA PIN" />
            </FloatingLabel>

            <Button color="success" onClick={createClient}>{submitText}</Button>

        </div>
    </Modal>
    </div>
  )
}
